import React, { lazy, Suspense } from 'react'
import { createHashRouter, createRoutesFromElements, Outlet, Route, RouterProvider } from 'react-router-dom'
import { ProtectedRouteConstants, RouteConstants, RouteParameters } from './navigation-types'
import Erko from '../screens/erko/Erko'
import Login from '../screens/login/Login'
import NotFound from '../screens/notfound/NotFound'
import ProtectedRoutes from './ProtectedRoutes'
import Navbar from '../components/Navbar'
import Logout from '../screens/login/Logout'

const Form = lazy(() => import('../screens/form/Form'))
const AdminForm = () => (
    <Suspense
        fallback={
            <div className='min-h-screen flex items-center justify-center text-secondary' role='status'>
                Načítám správu webu…
            </div>
        }
    >
        <Form />
    </Suspense>
)

const router = createHashRouter(
    createRoutesFromElements(
        <Route
            element={
                <>
                    <Navbar />
                    <Outlet />
                </>
            }
        >
            <Route path={RouteConstants.home} element={<Erko />} />
            <Route path={RouteConstants.login} element={<Login />} />

            {/* LOGIN ONLY PATHS */}
            <Route
                element={
                    <ProtectedRoutes>
                        <Outlet />
                    </ProtectedRoutes>
                }
            >
                <Route path={ProtectedRouteConstants.form} element={<AdminForm />} />
                <Route path={ProtectedRouteConstants.logout} element={<Logout />} />
                <Route path={ProtectedRouteConstants.form + RouteParameters.uuid} element={<AdminForm />} />
            </Route>
            <Route path='*' element={<NotFound />} />
        </Route>
    )
)

const MainNavigation: React.FC = () => <RouterProvider router={router} />

export default MainNavigation
